// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import globalMixins from './mixins'
import VueI18n from 'vue-i18n'
import locales from '@/locales'
import VTooltip from 'v-tooltip'
import Meta from 'vue-meta'
import SocialSharing from 'vue-social-sharing'

// Vue.config.productionTip = false

// Language setup
Vue.use(VueI18n)
Vue.config.lang = 'sr'
Object.keys(locales).forEach(function(lang) {
  Vue.locale(lang, locales[lang])
})

// Networking
Vue.use(VueResource)
Vue.http.options.root = 'https://api.mons.rs'
// Vue.http.options.root = 'http://localhost:8000'

// Add global mixins and components
Vue.use(globalMixins)
Vue.use(VTooltip)
Vue.use(Meta)
Vue.use(SocialSharing)

router.beforeEach(function(to, from, next) {
  window.scrollTo(0, 0)
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js